import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
	},
	{
		path: "/info/:id",
		name: "Info",
		component: () => import("../views/Info"),
	},
	// {
	// 	path: "/:pathMatch(.*)*",
	// 	redirect: "/",
	// },
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
